<dx-data-grid [dataSource]="scadenzeDipendenti" [showBorders]="true" [focusedRowEnabled]="false" [focusedRowIndex]="0"
    [columnAutoWidth]="true" [showColumnLines]="true" [showRowLines]="true" [columnHidingEnabled]="false"
    (onRowDblClick)="goToDipendente($event)">

    <dxo-paging [pageSize]="10"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
    <dxo-filter-row [visible]="false"></dxo-filter-row>

    <dxi-column dataField="codCope" [visible]="false" width="80">
    </dxi-column>
    <dxi-column dataField="idDipendente" [visible]="idDipendente == undefined" caption="Dipendente">
        <dxo-lookup [dataSource]="listDipendenti" valueExpr="id" [displayExpr]="getDipendenteDisplayExpr"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="eseguito" width="100" [visible]="false">
    </dxi-column>

    <dxi-column dataField="data" caption="Data" format="dd/MM/yyyy" dataType="date" width="150" [sortIndex]="1"
        sortOrder="desc">
    </dxi-column>

    <dxi-column dataField="descrizione">
    </dxi-column>
    <dxi-column
    caption="STATO"
    [allowSorting]="false"
    [allowFiltering]="false"
    cellTemplate="statoConsegna">
  </dxi-column>

  <div *dxTemplate="let d of 'statoConsegna'">
    @if (isScaduto(d.data.data)) {
      <span class="badge text-white bg-danger" style="font-size:12px">Scaduto</span>
    }

    @if (!isScaduto(d.data.data) && isInScadenza(d.data.data)) {
      <span class="badge text-dark bg-warning" style="font-size:12px">In scadenza</span>
    }
  </div>

</dx-data-grid>